import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SimpleCallback } from 'platform-components';

import type { KPK_JOIN_ERROR_IDS } from '../constants';
import type { ExtendedTeacherKPK, TeacherKPKStream, TeacherKPKsStoreState } from './types';

const initialState: TeacherKPKsStoreState = {
    teacherKPKs: [],
    teacherKPKsStream: null,
    getTeacherKPKsLoading: true,

    postTeacherKPKJoinLoading: false,

    postTeacherKPKJoinByCodeLoading: false,
    teacherKPKJoinByCodeErrorId: null,

    postTeacherKPKsUpdateThreadLoading: false,
};

const slice = createSlice({
    name: 'TEACHER_KPKS',
    initialState,
    reducers: {
        // Запрос за всеми КПК
        getTeacherKPKsRequest: (state) => {
            // saga
            state.getTeacherKPKsLoading = true;
        },
        getTeacherKPKsSuccess: (
            state,
            action: PayloadAction<{ extendedKPKs: ExtendedTeacherKPK[]; stream: TeacherKPKStream | null }>
        ) => {
            state.getTeacherKPKsLoading = false;
            state.teacherKPKs = action.payload.extendedKPKs;
            state.teacherKPKsStream = action.payload.stream;
        },
        getTeacherKPKsError: (state) => {
            state.getTeacherKPKsLoading = false;
        },

        // Присоединение учителя к курсу
        postTeacherKPKJoinRequest: (
            state,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            action: PayloadAction<{
                courseTemplateId: number | null;
                onSuccess?: (courseId: number) => void;
                onError?: SimpleCallback;
            }>
        ) => {
            state.postTeacherKPKJoinLoading = true;
        },
        postTeacherKPKJoinSuccess: (
            state,
            action: PayloadAction<{
                courseTemplateId: number;
                courseId: number;
            }>
        ) => {
            const { courseId, courseTemplateId } = action.payload;
            const teacherKPK = state.teacherKPKs[courseTemplateId];

            if (teacherKPK) {
                teacherKPK.courseId = courseId;
            }

            state.postTeacherKPKJoinLoading = false;
        },
        postTeacherKPKJoinError: (state) => {
            state.postTeacherKPKJoinLoading = false;
        },

        // Присоединение учителя к курсу по коду
        postTeacherKPKJoinByCodeRequest: (
            state,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            action: PayloadAction<{
                courseTemplateId: number | null;
                code: string;
                onSuccess?: (courseId: number) => void;
            }>
        ) => {
            state.teacherKPKJoinByCodeErrorId = null;
            state.postTeacherKPKJoinByCodeLoading = true;
        },
        postTeacherKPKJoinByCodeSuccess: (state) => {
            state.postTeacherKPKJoinByCodeLoading = false;
        },
        postTeacherKPKJoinByCodeError: (state) => {
            state.postTeacherKPKJoinByCodeLoading = false;
        },
        setTeacherKPKJoinByCodeErrorId: (state, action: PayloadAction<KPK_JOIN_ERROR_IDS | null>) => {
            state.teacherKPKJoinByCodeErrorId = action.payload;
        },

        // Обновление потока
        postTeacherKPKsUpdateThreadRequest: (
            state,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            action: PayloadAction<{ onSuccess: SimpleCallback; courseId: ExtendedTeacherKPK['courseId'] }>
        ) => {
            // saga
            state.postTeacherKPKsUpdateThreadLoading = true;
        },
        postTeacherKPKsUpdateThreadSuccess: (state) => {
            state.postTeacherKPKsUpdateThreadLoading = false;
        },
        postTeacherKPKsUpdateThreadError: (state) => {
            state.postTeacherKPKsUpdateThreadLoading = false;
        },
    },
});

export const actions = slice.actions;
export const teacherKPKsReducer = slice.reducer;
